import script from "./SubmitDone.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubmitDone.vue?vue&type=script&lang=ts&setup=true"

import "./SubmitDone.vue?vue&type=style&index=0&id=1012b283&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1012b283"]])

export default __exports__